module.exports = __webpack_public_path__ + "static/media/lens_as.e53dc009.png";